import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateMask } from '../api';
import { MaskForm } from '../components';
import { MaskFormValues } from '../validations';

export const NewMaskPage: FC = () => {
  const navigate = useNavigate();

  const { createMaskMutation, processMaskMutation, getUploadUrlDataMutation } =
    useCreateMask();

  const saveMask = async (values: MaskFormValues) => {
    try {
      const { maskId } = await getUploadUrlDataMutation.mutateAsync({
        file: values.maskUrl as File,
      });

      await processMaskMutation.mutateAsync({ maskId });

      await createMaskMutation.mutateAsync({
        id: maskId,
        name: values.name,
      });
      navigate(Routes.Masks, { replace: true });
      toast.success(`Mask “${values.name}” added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <MaskForm onSubmit={saveMask}>
      <PageHeader
        title="New Mask"
        asChildPage
        backPath={Routes.Masks}
        actions={[
          <Button
            key="create-mask"
            type="submit"
            data-testid="create-mask-button"
            isLoading={
              createMaskMutation.isPending ||
              processMaskMutation.isPending ||
              getUploadUrlDataMutation.isPending
            }
            startIcon={<PlusSquareIcon />}
          >
            Create new mask
          </Button>,
        ]}
      />
    </MaskForm>
  );
};
